
import { useSelector } from 'react-redux';

export default function useAuthLoading() {
    const authState = useSelector(state => state.auth);
    return authState.loading;
}
